<template>

    <div class="map-wrap">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div><h4 class="card-title m-b-0 title-font">{{$t('dashBoard.cSysDayToDaySales.salesComparison')}}</h4></div>
                    <!-- <div class="ml-auto">
                        <div class="dl">
                            <div class="select-icon-mask"><select
                                    class="custom-select border-0 text-muted">
                                <option value="0" selected="selected">August 2018</option>
                                <option value="1">May 2018</option>
                                <option value="2">March 2018</option>
                                <option value="3">June 2018</option>
                            </select></div>
                        </div>
                    </div> -->
                </div>
                <div class="chart-wrap" v-if="todaySales.length!=0">
                    <CChartBarDouble :todaySales="todaySales" :lastWeek="lastWeek"
                                      :chartLabel="chartLabel"  background-color="danger"/>
                </div>
                <div v-if="sysBookingNum && sysBookingNum.toproute">
                <div  class="row m-t-40 text-center text-lg-left">
                    <div class="col-xs-12 col-md-4" v-for="(routes,index) in sysBookingNum.toproute" :key="'routes'+index">
                        <div class="mb-2 mt-2"><span v-c-tooltip.hover="{ content: $t('dashBoard.cSysDayToDaySales.noOfBookingsTooltip') , active:false }" class="label  label-rounded" :class="{'label-danger' : routes.route_noofbookings <= 2 , 'label-success' : routes.route_noofbookings >= 2 }">{{routes.route_noofbookings}}
                          </span>

                            <h5 class="font-normal text-muted m-t-10 m-b-5">{{routes.route}}</h5>
                            <span v-c-tooltip.hover="{ content: $t('dashBoard.cSysDayToDaySales.todaySalesTooltip') , active:false , placement:'right'}" class="font-20 font-medium">{{routes.route_currency+' '}}{{routes.route_totalvalue}}
                              
                              <!-- <span class="font-14 font-normal text-muted">($3549.54)</span> -->
                              </span>
                        </div>
                    </div>
                   
                </div>
                </div>
            </div>
        </div>
    </div>


<!--  <CCard >-->
<!--        <CCardHeader>Sales comparison - Today vs Same day last week</CCardHeader>-->
<!--        -->
<!--        <CCardBody</CCardBody>        -->
<!--      </CCard>-->
</template>
<script>
import Logger from "../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../router/index";
import apiWeeklySales from "./../../../services/apiWeeklySales";
import CChartBarDouble from "../../chart/CChartBarDouble"
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../config/API_DATA";
import apiDayToDaySales from "../../../services/apiDayToDaySales"
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS } from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import SERVICE_URL from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../util/util";
var moment = require("moment");
export default {


   data () {
    return {
      //  dayToDaySalesRes:null ,
       todaySales : [],
       lastWeek : [],
       chartLabel : []
    }
   },
components:{
    CChartBarDouble
},
props: {
  dayToDaySalesRes:{
     type: Object,
      default: null
  },
  sysBookingNum:{
     type: Object,
      default: null
  }
  },

 computed:{
   ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),         
        
   },

async created(){
  if(this.ADMIN_SIGNIN_RES){
        // let dayToDaySalesRes = await this.getDayToDaySales();

        let dataSets = this.toGetDataSets(this.dayToDaySalesRes);
        this.todaySales = dataSets[0].todaySalesdata;
        this.lastWeek = dataSets[1].lastWeekdata;
      }
},

methods:{

  showAlert(val) {
                this.$emit("showAlert", val);
            },

  toGetDataSets(pdayToDaySalesRes) {
          let retValue=[{
            todaySalesdata:[],
          },
          {
            lastWeekdata:[],
          }];
          let dateValues=[];
         
          try {
            if(BaseConfiguration.isDebug) console.log("toGetDataSets");
            if(pdayToDaySalesRes){
                if(pdayToDaySalesRes.dayTodaySales.todaysales){
                    for (let i = 0; i < pdayToDaySalesRes.dayTodaySales.todaysales.length; i++) {
                      //  dateValues.push(this.$options.filters.formatDate(pdayToDaySalesRes.dayTodaySales.todaysales[i].json_build_object.hour, "hh:mm A"));                      
                       dateValues.push(this.$options.filters.formatDate(new Date(pdayToDaySalesRes.dayTodaySales.todaysales[i].json_build_object.ts), "h A"))
                        retValue[0].todaySalesdata.push(pdayToDaySalesRes.dayTodaySales.todaysales[i].json_build_object.Sales)
                    }
                }
                if(pdayToDaySalesRes.dayTodaySales.lastweek_sameday){
                    for (let i = 0; i < pdayToDaySalesRes.dayTodaySales.lastweek_sameday.length; i++) {
                      //  dateValues.push(this.$options.filters.formatDate(pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.ts, "hh:mm A"));                      
                       dateValues.push(this.$options.filters.formatDate(new Date(pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.ts), "h A"))
                        retValue[1].lastWeekdata.push(pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.Sales)
                    }
                }
            }
            this.chartLabel = [...new Set(dateValues)];
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_WEEKLY_SALES,
                    "error in toGetDataSets",
                    err.toString(),
                    "toGetDataSets",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
      }, 

       async getDayToDaySales() {
      let returnValue;
      try {
        let dayToDaySalesReq = apiDayToDaySales.buildRequest();
        if (dayToDaySalesReq) {
          let dayToDaySalesRes = await apiDayToDaySales.getResponse(dayToDaySalesReq);
          if (VALIDATE_SUCCESS_RES(dayToDaySalesRes)) {
            returnValue = dayToDaySalesRes.data.data;
            
          } else {
            let error = getErrorMessage(dayToDaySalesRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            } 
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.DASHBOARD,
          "error in  getDayToDaySales",
          err.toString(),
          " getDayToDaySales()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
}
  
}

</script>
<style scoped>
.tooltip .tooltiptext {
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
}
</style>